import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/components/Breadcrumb.css';

interface BreadcrumbProps {
  currentPageTitle?: string;
}

/**
 * Breadcrumb navigation component to show page hierarchy
 */
const Breadcrumb: React.FC<BreadcrumbProps> = ({ currentPageTitle }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(path => path);
  
  // Create a mapping from paths to readable names and icons
  const pathMap: Record<string, {name: string, icon: string}> = {
    'app': {name: 'Home', icon: '🏠'},
    'create-story': {name: 'Create Story', icon: '✨'},
    'my-stories': {name: 'My Stories', icon: '📚'},
    'profile': {name: 'Profile', icon: '👤'},
    'settings': {name: 'Settings', icon: '⚙️'},
    'story': {name: 'My Story', icon: '📖'}
  };

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {/* Always show Home as first item */}
        <li className="breadcrumb-item">
          <Link to="/app">
            <span className="breadcrumb-icon">🏠</span>
            <span className="breadcrumb-text">Home</span>
          </Link>
        </li>
        
        {/* Show current page with proper icon and name */}
        {pathnames.length > 0 && pathnames[0] !== 'app' && (
          <li className="breadcrumb-item active">
            <Link to={`/${pathnames[0]}`}>
              {pathMap[pathnames[0]]?.icon && (
                <span className="breadcrumb-icon">{pathMap[pathnames[0]].icon}</span>
              )}
              <span className="breadcrumb-text">
                {currentPageTitle || 
                 (pathMap[pathnames[0]] ? pathMap[pathnames[0]].name : pathnames[0])}
              </span>
            </Link>
          </li>
        )}
      </ol>
      
      {/* Navigation buttons for quick access */}
      <div className="breadcrumb-actions">
        {Object.entries(pathMap).map(([path, info]) => (
          path !== 'app' && path !== pathnames[0] && (
            <Link 
              key={path} 
              to={`/${path}`} 
              className="breadcrumb-action-btn"
              title={info.name}
            >
              <span className="breadcrumb-action-icon">{info.icon}</span>
              <span className="breadcrumb-action-text">{info.name}</span>
            </Link>
          )
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumb; 